<template>
  <div>
    <div
      kbx-highlight-hover-container
      :style="highlightStyle.container">
      <div kbx-highlight-hover="top"></div>
      <div kbx-highlight-hover="right" :style="highlightStyle.right"></div>
      <div kbx-highlight-hover="bottom" :style="highlightStyle.bottom"></div>
      <div kbx-highlight-hover="left" :style="highlightStyle.left"></div>
      <div class="klickart-element-highlight-tool-container">
        <button
          @click="
            sidebarChangePanel('modifiers');
            sidebarChangeActiveButton('style');
            sidebarSetElement(highlightElement)"
          class="klickart-highlight-tool">
          <i class="fa fa-cog"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'sidebarChangePanel',
    'sidebarSetElement',
    'sidebarChangeActiveButton',
  ]),
  computed: mapGetters({
    highlightStyle: 'canvasHighlightStyle',
    highlightElement: 'canvasHighlightElement',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Highlight.vue?17d92904
 **/